import React, { Fragment, useState } from 'react'
import { Card, Col, Input, Label, Row, CardBody, Button } from 'reactstrap'
import { useReportCxc } from '../../../hooks/reports/useReportCxc'
import './styleReport.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from "primereact/inputtext";
import { Dialog } from 'primereact/dialog';
import reportCxcCompanyAltImage from '../../../assets/images/price/company-Ban.svg'
import { Badge } from 'primereact/badge';
import { Tag } from 'primereact/tag';
import Select from 'react-select';
import { useModal as useMorphingModal } from "react-morphing-modal";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Doughnut } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import { Line } from "react-chartjs-2";






export const IndexReportCxc = () => {

    const {
        loadingTotalIngress, loadingTableClients, lblTotalIngress, lblOutSideBalance, lblTotalClients,
        detailTransactionsByClients, listDetailTransactionsByClients,
        handleFilterByClient, handleFilterDate, number_format,
        handleCleanFilterByClient,

        // * FILTERS
        filterCredit, setFilterCredit,
        filterAccount, setFilterAccount,
        filterPayment, setFilterPayment,
        filterPendingPayment, setFilterPendingPayment,
        filterInvoiced, setFilterInvoiced,
        filterPendigInvoiced, setFilterPendigInvoiced,
        filterPreInvoice, setFilterPreInvoice,

        //* DOWNLOAD REPORT CXC
        DownloadReportCxc,

        // ? FILTER PAYMETHODS
        filterAmountCredit, setFilterAmountCredit,
        filterAmountDebit, setFilterAmountDebit,
        filterAmountTcredit, setFilterAmountTcredit,
        filterAmountTrasferencia, setFilterAmountTrasferencia,
        filterAmount, setFilterAmount,

        lblTotalPaidIngress, lblTotalPatient, loadingIdR,
        setDateStart, setDateEnd, dateStart, dateEnd, companyInfo,
        getBadgeStatus, dataViewCompany,
        listAgreement, valuId, handleChangeAgreement, filterId,
        loadingView2, loadingView1

        // ? SEARCH AGREEMENTS
        , searchQuery, handleSearchChange, setsearchView1,

        // ? CONFIGURATION CHART GLOBAL
        options, selectedCompany, visible, setVisible,

        // ? CONFIGURATION FILTER DATA TABLE
        rowExpansionTemplate, filteredData, calculatePaymentMethod, getstatusInvoice, getValueTax, tagInfo,
        getTransactionLabel, filteredClients,

        expandedRows, setExpandedRows, expandedRows2, setExpandedRows2,
        globalFilter, globalFilter2, setGlobalFilter2,
        nameCompany, setNameCompany,
        searchQuerys, setSearchQuerys,
        paymentType, setPaymentType,
        data, pageChart, setPageChart, totalPages,
        loadingDownload,
        downloadProgress


    } = useReportCxc();


    const topCompanies = [...(detailTransactionsByClients ?? [])]
        .sort((a, b) => (b.totalCredit ?? 0) - (a.totalCredit ?? 0))
        .slice(0, 5);

    const companyChartData = {
        labels: topCompanies.map(item => item.name_client),

        datasets: [
            {
                label: "Crédito",
                data: topCompanies.map(item => item.totalCredit ?? 0),

                borderColor: "#2563eb",
                backgroundColor: "#2563eb",

                borderWidth: 3,
                tension: 0.35,

                pointRadius: 5,
                pointHoverRadius: 7,

                pointBackgroundColor: "#2563eb",
                pointBorderColor: "#ffffff",
                pointBorderWidth: 2,

                fill: false
            },

            {
                label: "Pagado",
                data: topCompanies.map(item => item.totalPaid ?? 0),

                borderColor: "#10b981",
                backgroundColor: "#10b981",

                borderWidth: 3,
                tension: 0.35,

                pointRadius: 5,
                pointHoverRadius: 7,

                pointBackgroundColor: "#10b981",
                pointBorderColor: "#ffffff",
                pointBorderWidth: 2,

                fill: false
            },

            {
                label: "Pendiente",
                data: topCompanies.map(item => item.pruebe ?? 0),

                borderColor: "#f59e0b",
                backgroundColor: "#f59e0b",

                borderWidth: 3,
                borderDash: [6, 4],

                tension: 0.35,

                pointRadius: 5,
                pointHoverRadius: 7,

                pointBackgroundColor: "#f59e0b",
                pointBorderColor: "#ffffff",
                pointBorderWidth: 2,

                fill: false
            }
        ]
    };
    const currencyFormatter = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2
    });

    const companyChartOptions = {
        responsive: true,
        maintainAspectRatio: false,

        layout: {
            padding: {
                top: 5,
                right: 10,
                bottom: 5,
                left: 5
            }
        },

        interaction: {
            mode: "index",
            intersect: false
        },

        plugins: {
            legend: {
                display: true,
                position: "top",

                labels: {
                    usePointStyle: true,
                    pointStyle: "circle",
                    boxWidth: 9,
                    boxHeight: 9,
                    padding: 16,

                    color: "#475569",

                    font: {
                        size: 12,
                        weight: "500"
                    }
                }
            },

            tooltip: {
                enabled: true,

                backgroundColor: "#ffffff",
                titleColor: "#1e293b",
                bodyColor: "#475569",

                borderColor: "#e2e8f0",
                borderWidth: 1,

                padding: 14,

                cornerRadius: 10,

                displayColors: true,

                boxWidth: 8,
                boxHeight: 8,
                boxPadding: 6,

                titleFont: {
                    size: 12,
                    weight: "600"
                },

                bodyFont: {
                    size: 11,
                    weight: "500"
                },

                caretSize: 6,

                callbacks: {

                    title: function (items) {
                        return items[0]?.label ?? "";
                    },

                    label: function (context) {

                        const value = currencyFormatter.format(
                            context.raw ?? 0
                        );

                        return ` ${context.dataset.label}   ${value}`;
                    }
                }
            }
        },

        scales: {
            x: {
                grid: {
                    display: false
                },

                ticks: {
                    color: "#64748b",

                    font: {
                        size: 10,
                        weight: "500"
                    },

                    maxRotation: 0,
                    minRotation: 0,

                    callback: function (value) {
                        const label = this.getLabelForValue(value);

                        if (label.length > 15) {
                            return label.substring(0, 15) + "...";
                        }

                        return label;
                    }
                },

                border: {
                    display: false
                }
            },

            y: {
                beginAtZero: true,

                grid: {
                    color: "rgba(148, 163, 184, 0.15)",
                    drawBorder: false
                },

                border: {
                    display: false
                },

                ticks: {
                    color: "#64748b",

                    font: {
                        size: 10
                    },

                    callback: function (value) {
                        if (value >= 1000000) {
                            return `$${(value / 1000000).toFixed(1)}M`;
                        }

                        if (value >= 1000) {
                            return `$${(value / 1000).toFixed(0)}K`;
                        }

                        return `$${value}`;
                    }
                }
            }
        }
    };



    // * STYLES DATA TABLE
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "14px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "14px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
        zIndex: 2
    };







    const [search, setSearch] = useState("");






    // ? CONFIGURATION AGRUPED 
    const groupedByCompany = Object.values(
        listDetailTransactionsByClients.reduce((acc, item) => {
            const key = item.idClient;

            if (!acc[key]) {
                acc[key] = {
                    idClient: item.idClient,
                    nameClient: item.nameClient,
                    rows: []
                };
            }

            acc[key].rows.push(item);
            return acc;
        }, {})
    );

    const getCompanyTotal = (rows) => {
        const byWorkOrder = {};

        rows.forEach(r => {
            if (!byWorkOrder[r.idWorkOrder]) {
                byWorkOrder[r.idWorkOrder] =
                    (r.totalWorkOrder ?? 0) + (r.totalTax ?? 0);
            }
        });

        return Object.values(byWorkOrder).reduce((a, b) => a + b, 0);
    };

    const getAgreements = (rows) => {
        return Object.values(
            rows.reduce((acc, r) => {
                const key = r.nameAgreement ?? "Sin convenio";

                if (!acc[key]) {
                    acc[key] = {
                        nameAgreement: key,
                        total: 0
                    };
                }

                acc[key].total += (r.totalWorkOrder ?? 0) + (r.totalTax ?? 0);
                return acc;
            }, {})
        );
    };

    const [expandedCompany, setExpandedCompany] = useState(null);



    const filteredCompanies = groupedByCompany
        .filter(company => {
            if (!search) return true;

            const searchText = search.toLowerCase();

            const clientMatch = company.nameClient
                ?.toLowerCase()
                .includes(searchText);

            const agreements = getAgreements(company.rows);

            const agreementMatch = agreements.some(ag =>
                ag.nameAgreement
                    ?.toLowerCase()
                    .includes(searchText)
            );

            return clientMatch || agreementMatch;
        })


        .sort((a, b) =>
            getCompanyTotal(b.rows) - getCompanyTotal(a.rows)
        );
    const parseMoney = (val) => {
        if (!val) return 0;
        return Number(String(val).replace(/,/g, ''));
    };

    const dataBar = {
        labels: ['Cartera'],
        datasets: [
            {
                label: 'Pagado',
                data: [parseMoney(lblTotalPaidIngress)],
                backgroundColor: '#22c55e',
                borderRadius: 12
            },
            {
                label: 'Pendiente',
                data: [parseMoney(lblOutSideBalance)],
                backgroundColor: '#ef4444',
                borderRadius: 12
            }
        ]
    };

    const optionsBar = {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,

        layout: {
            padding: {
                top: 10,
                bottom: 0
            }
        },

        plugins: {
            legend: {
                display: true,
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'rect',
                    boxWidth: 12,
                    padding: 15,
                    font: {
                        size: 12
                    }
                }
            },

            tooltip: {
                enabled: false,

                external: function (context) {
                    let tooltipEl = document.getElementById('chart-tooltip');

                    if (!tooltipEl) {
                        tooltipEl = document.createElement('div');
                        tooltipEl.id = 'chart-tooltip';

                        tooltipEl.style.position = 'absolute';
                        tooltipEl.style.background = 'rgba(255,255,255,0.92)';
                        tooltipEl.style.backdropFilter = 'blur(10px)';
                        tooltipEl.style.webkitBackdropFilter = 'blur(10px)';
                        tooltipEl.style.color = '#1f2937';
                        tooltipEl.style.padding = '12px 14px';
                        tooltipEl.style.borderRadius = '14px';
                        tooltipEl.style.fontSize = '12px';
                        tooltipEl.style.boxShadow = '0 12px 35px rgba(0,0,0,0.12)';
                        tooltipEl.style.border = '1px solid rgba(229,231,235,0.8)';
                        tooltipEl.style.zIndex = 9999;
                        tooltipEl.style.minWidth = '220px';
                        tooltipEl.style.fontFamily = 'Inter, system-ui, sans-serif';
                        tooltipEl.style.transition = 'all 0.12s ease';

                        document.body.appendChild(tooltipEl);
                    }

                    const tooltipModel = context.tooltip;

                    if (tooltipModel.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        return;
                    }

                    const dataPoint = tooltipModel.dataPoints[0];
                    const datasetLabel = dataPoint.dataset.label;
                    const value = dataPoint.raw;
                    const color = dataPoint.dataset.backgroundColor;

                    const total = (context.chart.data.datasets || [])
                        .reduce((acc, ds) => acc + (ds.data[0] || 0), 0);

                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;

                    let html = `
        <div style="
            display:flex;
            align-items:center;
            justify-content:space-between;
            margin-bottom:8px;
        ">
            <div style="display:flex; align-items:center; gap:8px;">
                <span style="
                    width:10px;
                    height:10px;
                    border-radius:50%;
                    background:${color};
                "></span>

                <span style="font-weight:600; font-size:13px;">
                    ${datasetLabel}
                </span>
            </div>

            <span style="font-size:11px; color:#9ca3af;">
                ${percentage}%
            </span>
        </div>

        <div style="font-size:16px; font-weight:700; margin-bottom:6px;">
            ${new Intl.NumberFormat('es-MX', {
                        style: 'currency',
                        currency: 'MXN'
                    }).format(value)}
        </div>

        <div style="
            font-size:11px;
            color:#6b7280;
        ">
            Total cartera: ${new Intl.NumberFormat('es-MX', {
                        style: 'currency',
                        currency: 'MXN'
                    }).format(total)}
        </div>
        `;

                    tooltipEl.innerHTML = html;

                    const canvasPosition = context.chart.canvas.getBoundingClientRect();

                    const { caretX } = tooltipModel;
                    const element = dataPoint.element;

                    let left = canvasPosition.left + caretX + window.scrollX;

                    let top = canvasPosition.top + element.y + window.scrollY;
                    top = top + (element.height / 2) + 20;

                    const tooltipWidth = tooltipEl.offsetWidth;
                    const tooltipHeight = tooltipEl.offsetHeight;

                    left = left - (tooltipWidth / 2);

                    left = Math.max(10, Math.min(left, window.innerWidth - tooltipWidth - 10));
                    top = Math.max(10, Math.min(top, window.innerHeight - tooltipHeight - 10));

                    tooltipEl.style.opacity = 1;
                    tooltipEl.style.left = `${left}px`;
                    tooltipEl.style.top = `${top}px`;
                }
            },
            datalabels: {
                color: '#ffffff',
                font: {
                    weight: 'bold',
                    size: 13
                },
                anchor: 'center',
                align: 'center',

                formatter: function (value) {
                    if (!value || value === 0) return '';

                    return new Intl.NumberFormat('es-MX', {
                        style: 'currency',
                        currency: 'MXN',
                        maximumFractionDigits: 0
                    }).format(value);
                }
            }
        },

        interaction: {
            mode: 'nearest',
            intersect: false,
            axis: 'x'
        },

        scales: {
            x: {
                stacked: true,
                grid: {
                    color: 'rgba(0,0,0,0.05)'
                },
                ticks: {
                    font: { size: 11 },
                    callback: (value) =>
                        new Intl.NumberFormat('es-MX', {
                            style: 'currency',
                            currency: 'MXN',
                            maximumFractionDigits: 0
                        }).format(value)
                }
            },
            y: {
                stacked: true,
                display: true,
                ticks: {
                    font: {
                        size: 12,
                        weight: '600'
                    }
                }
            }
        },

        datasets: {
            bar: {
                barThickness: 50,
                borderRadius: 6
            }
        }
    };
    console.log("🚀 ~ IndexReportCxc ~ optionsBar:", optionsBar)



    // const recoveryPercentage =
    //     !loadingTotalIngress
    //         ? ((lblTotalPaidIngress / lblTotalIngress) * 100).toFixed(1)
    //         : 0;


    console.log("🚀 ~ IndexReportCxc ~ lblTotalPaidIngress:", lblTotalPaidIngress)

    console.log("🚀 ~ IndexReportCxc ~ lblTotalIngress:", lblTotalIngress)


    console.log((lblTotalPaidIngress / lblTotalIngress) * 100);

    const paid = Number((lblTotalPaidIngress || "0").toString().replace(/,/g, ''));
    const total = Number((lblTotalIngress || "0").toString().replace(/,/g, ''));

    const recoveryPercentage =
        !loadingTotalIngress > 0
            ? ((paid / total) * 100).toFixed(1)
            : 0;





    return (
        <Fragment>
            <Dialog
                header={
                    <Col sm="12">
                        <Row>
                            <Col sm="1" className='pl-0 pr-0' >
                                <img src={reportCxcCompanyAltImage} width="50%" alt="Empresa" />
                            </Col>
                            <Col sm="7" className='' >
                                <span style={{ color: "#f59e0b", fontSize: "12px" }}>
                                    {selectedCompany?.nameCompany ?? "Empresa"}
                                </span>
                            </Col>
                            <Col sm="4" className='pl-0 pr-0 '>
                                <label style={{ fontSize: "12px" }}>Total:&nbsp;</label>
                                {
                                    selectedCompany
                                        ? <label style={{ fontSize: "12px" }}>
                                            {
                                                number_format(
                                                    selectedCompany.patientDetails
                                                        .filter(p => p.status_oreder === "Vigente")
                                                        .reduce((sum, p) => sum + (p.amount || 0), 0),
                                                    2
                                                )
                                            }
                                        </label>
                                        : ""
                                }
                            </Col>
                        </Row>
                    </Col>
                }
                visible={visible}
                maximizable
                style={{ width: "50vw", padding: "0.1px" }}
                onHide={() => setVisible(false)}
                headerStyle={{
                    backgroundColor: '#0d3b59',
                    color: 'white',
                    fontWeight: 'bold',
                    padding: '4px',
                }}
                pt={{
                    header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
            >
                {selectedCompany ? (
                    <>
                        <Col sm="12" className='pt-2' >
                            <Row>
                                <Col sm="8">
                                </Col>
                                <Col sm="4" style={{ textAlign: "end" }} >
                                    <span className="p-input-icon-left">
                                        <i className="pi pi-search" />
                                        <InputText type="search" className="pl-6" onInput={(e) => setGlobalFilter2(e.target.value)} style={{ width: "auto" }} />
                                    </span>
                                </Col>
                            </Row>
                        </Col> <br />
                        <DataTable
                            value={selectedCompany.patientDetails}
                            globalFilter={globalFilter2}
                            className="data-table p-datatable-striped p-datatable-sm"
                            responsiveLayout="scroll"
                            dataKey="id_patient"
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 30, 40, 50]}
                            expandedRows={expandedRows2}
                            onRowToggle={(e) => setExpandedRows2(e.data)}
                        >
                            <Column
                                header="#"
                                body={(rowData, { rowIndex }) => rowIndex + 1}
                                style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    width: "5%",
                                }}
                                headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                }}

                            />
                            <Column
                                field="name_patient"
                                header="Paciente"
                                headerStyle={{ backgroundColor: "#0d3b59", color: "#fff", fontWeight: "bold", fontSize: "12px", textAlign: 'center' }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                                sortable
                            />
                            <Column
                                field="nim"
                                header="NIM"
                                headerStyle={{ backgroundColor: "#0d3b59", color: "#fff", fontWeight: "bold", fontSize: "12px", textAlign: 'center' }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                                sortable
                            />
                            <Column
                                field="branchs"
                                header="Sucursal"
                                headerStyle={{ backgroundColor: "#0d3b59", color: "#fff", fontWeight: "bold", fontSize: "12px", textAlign: 'center' }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                                sortable
                            />
                            <Column
                                field="amount"
                                header="Monto"
                                body={(rowData) => `$${rowData.amount}`}
                                headerStyle={{ backgroundColor: "#0d3b59", color: "#fff", fontWeight: "bold", fontSize: "12px", textAlign: 'center' }}
                                style={{ fontSize: "12px", textAlign: 'center' }}
                                sortable
                            />
                            <Column
                                field="status_oreder"
                                header="Estatus"
                                sortable
                                body={(rowData) => {
                                    const label = rowData.status_oreder;
                                    return (
                                        <Badge
                                            value={label}
                                            severity={getBadgeStatus(label)}
                                            style={{ textAlign: "center", fontSize: "10px" }}
                                        />
                                    );
                                }}
                                headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                }}
                                style={{
                                    fontSize: "10px",
                                    textAlign: "center",
                                    width: "10%",
                                }}
                            />
                        </DataTable>

                    </>
                ) : (
                    <p>No hay información para mostrar.</p>
                )}
            </Dialog>
            {
                // * new configuration
            }
            <div className='container-global-zoom-Overdue'>
                <div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
                    <Card style={{
                        marginBottom: '15px',
                        background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                        border: 'none',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                    }}>
                        <CardBody style={{ padding: '18px 25px' }}>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center w-100">
                                    <div style={{
                                        width: '50px',
                                        height: '50px',
                                        borderRadius: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginRight: '15px'
                                    }}>
                                        <img
                                            alt="flask"
                                            className="img-fluid text-info mr-2"
                                            src={require("../../../assets/images/laboratory-External/report-cxc.svg")}
                                            style={{ width: "80px", height: "80px" }}
                                        />
                                    </div>

                                    <div style={{ width: '100%' }}>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '10px'
                                        }}>

                                            <h4
                                                style={{
                                                    color: '#fff',
                                                    fontWeight: 700,
                                                    fontSize: '20px',
                                                    margin: 0
                                                }}
                                            >
                                                Cuentas por cobrar
                                            </h4>

                                            <div style={{
                                                marginLeft: 'auto',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                background: 'rgba(255,255,255,0.08)',
                                                padding: '6px 12px',
                                                borderRadius: '12px',
                                                color: '#fff',
                                                fontSize: '12px',
                                                fontWeight: 600
                                            }}>
                                                <i className="fa fa-calendar" />

                                                <span>Periodo:</span>

                                                <span style={{ fontWeight: 700 }}>
                                                    {dateStart || '---'}
                                                </span>

                                                <span>-</span>

                                                <span style={{ fontWeight: 700 }}>
                                                    {dateEnd || '---'}
                                                </span>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>


                    <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
                        <Col sm="12" className='pt-3'>
                            <Row>
                                <Col sm="12">
                                    <div style={{
                                        marginTop: '1px',
                                    }}>
                                        <Col sm="12" className='p-l-0 p-r-0' >
                                            {
                                                // * DASHBOARD CONFIGURATION INDICADORES
                                            }

                                            <div
                                                className="mb-3"
                                                style={{
                                                    display: 'flex',
                                                    gap: '12px',
                                                    overflowX: 'auto'
                                                }}
                                            >

                                                {/* TOTAL CLIENTES */}
                                                <div style={{ minWidth: '220px', flex: '1' }}>
                                                    <div className={`card dashboard-card-overduel ${loadingTotalIngress ? "loading-kpi-card" : ""}`}>
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <span className="card-title-overduel">Total de clientes</span>
                                                            <span className="trend-overduel up-overduel">
                                                                <i className={`fa fa-users f-30 ${loadingTotalIngress ? "pulse-icon" : ""}`}></i>
                                                            </span>
                                                        </div>

                                                        <h2 className="card-value-overduel text-primary">
                                                            {loadingTotalIngress ? <span className="skeleton-line"></span> : lblTotalClients}
                                                        </h2>

                                                        <div className="card-sub-overduel">Clientes</div>
                                                        {/* <div className="sparkline-overduel"></div> */}
                                                    </div>
                                                </div>

                                                {/* INGRESO */}
                                                <div style={{ minWidth: '240px', flex: '1.2' }}>
                                                    <div className={`card dashboard-card-overduel ${loadingTotalIngress ? "loading-kpi-card" : ""}`}>
                                                        <div className="d-flex justify-content-between">
                                                            <span className="card-title-overduel">Ingreso Mensual</span>
                                                            <span className="trend-overduel down-overduel">
                                                                <i className={`icon-alert txt-warning f-30 ${loadingTotalIngress ? "pulse-icon" : ""}`}></i>
                                                            </span>
                                                        </div>

                                                        <h2 className="card-value-overduel">
                                                            {loadingTotalIngress ? <span className="skeleton-line"></span> : `$${number_format(lblTotalIngress, 2)}`}
                                                        </h2>

                                                        <div className="card-sub-overduel">MXN</div>
                                                        {/* <div className="sparkline-overduel orange-overduel"></div> */}
                                                    </div>
                                                </div>

                                                {/* PAGADO */}
                                                <div style={{ minWidth: '240px', flex: '1.2' }}>
                                                    <div className={`card dashboard-card-overduel card-danger-overduel2 ${loadingTotalIngress ? "loading-kpi-card" : ""}`}>
                                                        <div className="d-flex justify-content-between">
                                                            <span className="card-title-overduel">Ingreso Pagado</span>
                                                            <span className="trend-overduel">
                                                                <i className={`pi pi-exclamation-circle f-30 ${loadingTotalIngress ? "pulse-icon" : ""}`}></i>
                                                            </span>
                                                        </div>

                                                        <h2 className="card-value-overduel text-success">
                                                            {loadingTotalIngress ? <span className="skeleton-line"></span> : `$${number_format(lblTotalPaidIngress, 2)}`}
                                                        </h2>

                                                        <div className="card-sub-overduel">MXN</div>
                                                        {/* <div className="sparkline-overduel green-overduel"></div> */}
                                                    </div>
                                                </div>

                                                <div style={{ minWidth: '240px', flex: '1.2' }}>

                                                    <div className={`card dashboard-card-overduel  ${Number((lblOutSideBalance || "0").toString().replace(/,/g, '')) > 0
                                                        ? 'card-danger-overduel'
                                                        : ''}   ${loadingTotalIngress ? "loading-kpi-card" : ""}`}>
                                                        <div className="d-flex justify-content-between">
                                                            <span className="card-title-overduel">Saldo Pendiente</span>
                                                            <span className="trend-overduel down-overduel">
                                                                <i className={`pi pi-arrow-down f-30 ${loadingTotalIngress ? "pulse-icon" : ""}`}></i>
                                                            </span>
                                                        </div>

                                                        <h2 className="card-value-overduel text-danger">
                                                            {loadingTotalIngress ? <span className="skeleton-line"></span> : `$${number_format(lblOutSideBalance, 2)}`}
                                                        </h2>

                                                        <div className="card-sub-overduel">MXN</div>
                                                        {/* <div className="sparkline-overduel red-overduel"></div> */}
                                                    </div>
                                                </div>



                                                <div style={{ minWidth: '220px', flex: '1' }}>
                                                    <div className={`card dashboard-card-overduel ${loadingTotalIngress ? "loading-kpi-card" : ""}`}>
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <span className="card-title-overduel">Recuperado</span>
                                                            <span className="trend-overduel up-overduel txt-success">
                                                                <i className={`fa fa-percent f-30 ${loadingTotalIngress ? "pulse-icon" : ""}`}></i>
                                                            </span>
                                                        </div>

                                                        <h2 className="card-value-overduel ">
                                                            {loadingTotalIngress ? <span className="skeleton-line"></span>
                                                                : `${recoveryPercentage}%`}
                                                        </h2>

                                                        <div className="card-sub-overduel">.</div>
                                                        {/* <div className="sparkline-overduelp"></div> */}
                                                    </div>
                                                </div>

                                            </div>


                                            {
                                                // * CHART
                                            }
                                            <Col sm="12" className="pb-3 pl-0 pr-0">
                                                {!loadingTotalIngress && (
                                                    <div
                                                        style={{
                                                            width: "100%",
                                                            height: "180px",
                                                            marginBottom: "16px",
                                                            border: "1px solid #e5e7eb",
                                                            borderRadius: "10px",
                                                            padding: "10px 16px",
                                                            background: "#ffffff",
                                                            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                                                            boxSizing: "border-box",
                                                            overflow: "hidden"
                                                        }}
                                                    >

                                                        <div
                                                            style={{ textAlign: "left" }}
                                                            className="non-conforming-chart-header"
                                                        >
                                                            <div className="non-conforming-chart-icon">
                                                                <i className="fa fa-database f-20"></i>
                                                            </div>

                                                            <div>
                                                                <h6>
                                                                    Estado de la Cartera
                                                                </h6>

                                                                <label style={{ fontSize: "12px" }}>
                                                                    Distribución del saldo total entre montos pagados y montos pendientes
                                                                </label>
                                                            </div>
                                                        </div>

                                                        <div
                                                            style={{
                                                                width: "100%",
                                                                height: "105px"
                                                            }}
                                                        >
                                                            <Bar
                                                                key={`${lblTotalPaidIngress}-${lblOutSideBalance}`}
                                                                data={dataBar}
                                                                options={optionsBar}
                                                                plugins={[ChartDataLabels]}
                                                            />
                                                        </div>

                                                    </div>
                                                )}
                                            </Col>
                                            {
                                                // * TABLE CLIENTES - CONVENIOS
                                            }
                                            <Col sm="12" className={setsearchView1 ? "d-none" : 'pl-0 pt-3'}   >
                                                <Row className='pt-3' >

                                                    <Col sm="5">
                                                        <div
                                                            style={{
                                                                height: "380px",
                                                                width: "100%",
                                                                border: "1px solid #e5e7eb",
                                                                borderRadius: "14px",
                                                                padding: "10px",
                                                                backgroundColor: "#ffffff",
                                                                boxSizing: "border-box",
                                                                boxShadow: "0 4px 14px rgba(0,0,0,.05)",
                                                                overflow: "hidden",
                                                                display: "flex",
                                                                flexDirection: "column"
                                                            }}
                                                        >

                                                            {/* HEADER */}
                                                            <div
                                                                style={{
                                                                    textAlign: "left",
                                                                    flexShrink: 0
                                                                }}
                                                                className="non-conforming-chart-header"
                                                            >
                                                                <div className="non-conforming-chart-icon">
                                                                    <i className="fa fa-line-chart f-24"></i>
                                                                </div>

                                                                <div>
                                                                    <h6>
                                                                        Montos consumidos por los clientes
                                                                    </h6>

                                                                    <label style={{ fontSize: "12px" }}>
                                                                        Comparativo de montos de crédito, pagado y pendiente por cliente
                                                                    </label>
                                                                </div>
                                                            </div>

                                                            {/* GRÁFICA */}
                                                            <div
                                                                style={{
                                                                    flex: 1,
                                                                    minHeight: 0,
                                                                    width: "100%",
                                                                    position: "relative",
                                                                    marginTop: "5px"
                                                                }}
                                                            >
                                                                <Line
                                                                    data={companyChartData}
                                                                    options={companyChartOptions}
                                                                />
                                                            </div>

                                                        </div>
                                                    </Col>
                                                    <Col sm="7">

                                                        <div
                                                            style={{
                                                                height: "380px",
                                                                position: "relative",
                                                                background: "#fff",
                                                                border: "1px solid #e5e7eb",
                                                                borderRadius: "14px",
                                                                padding: "10px",
                                                                boxShadow: "0 4px 14px rgba(0,0,0,.05)",
                                                                overflow: "hidden",
                                                                boxSizing: "border-box"
                                                            }}
                                                        >
                                                            {/* LOADING */}
                                                            {loadingTotalIngress ? (
                                                                <div
                                                                    style={{
                                                                        height: "100%",
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        justifyContent: "flex-start",
                                                                        alignItems: "center",
                                                                        textAlign: "center",
                                                                        padding: "20px",
                                                                        paddingTop: "85px"
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            width: "48px",
                                                                            height: "48px",
                                                                            border: "4px solid #e5e7eb",
                                                                            borderTop: "4px solid #1d5b83",
                                                                            borderRadius: "50%",
                                                                            animation: "spin 1s linear infinite",
                                                                            marginBottom: "15px"
                                                                        }}
                                                                    ></div>

                                                                    <h6
                                                                        style={{
                                                                            margin: 0,
                                                                            color: "#0d3b59",
                                                                            fontWeight: 700
                                                                        }}
                                                                    >
                                                                        Cargando información
                                                                    </h6>

                                                                    <small
                                                                        style={{
                                                                            color: "#6c757d",
                                                                            marginTop: "6px",
                                                                            fontSize: "13px"
                                                                        }}
                                                                    >
                                                                        Consultando datos del periodo seleccionado...
                                                                    </small>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <div
                                                                        style={{ textAlign: "left" }}
                                                                        className="non-conforming-chart-header"
                                                                    >
                                                                        <div className="non-conforming-chart-icon">
                                                                            <i className="fa fa-pie-chart f-24"></i>
                                                                        </div>

                                                                        <div>
                                                                            <h6>
                                                                                Monto de crédito por cliente
                                                                            </h6>

                                                                            <label style={{ fontSize: "12px" }}>
                                                                                Participación de los principales clientes en el saldo del crédito
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                    {/* SELECT PREMIUM */}
                                                                    <div
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "10px",
                                                                            right: "10px",
                                                                            zIndex: 10
                                                                        }}
                                                                    >
                                                                        <select
                                                                            value={pageChart}
                                                                            onChange={(e) =>
                                                                                setPageChart(Number(e.target.value))
                                                                            }
                                                                            style={{
                                                                                border: "1px solid #dbeafe",
                                                                                borderRadius: "10px",
                                                                                padding: "7px 14px",
                                                                                fontSize: "13px",
                                                                                fontWeight: "600",
                                                                                background: "linear-gradient(135deg,#eff6ff,#dbeafe)",
                                                                                color: "#0B3C5D",
                                                                                boxShadow: "0 4px 12px rgba(0,0,0,.08)",
                                                                                outline: "none",
                                                                                cursor: "pointer"
                                                                            }}
                                                                        >
                                                                            {Array.from(
                                                                                { length: totalPages },
                                                                                (_, i) => (
                                                                                    <option
                                                                                        key={i + 1}
                                                                                        value={i + 1}
                                                                                    >
                                                                                        Top {i * 10 + 1} - {(i + 1) * 10}
                                                                                    </option>
                                                                                )
                                                                            )}
                                                                        </select>
                                                                    </div>

                                                                    <div
                                                                        style={{
                                                                            height: "310px",
                                                                            width: "100%",
                                                                            marginTop: "5px"
                                                                        }}
                                                                    >
                                                                        <Doughnut
                                                                            data={data}
                                                                            options={options}
                                                                        />
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>

                                                    </Col>


                                                </Row>
                                            </Col>
                                            {
                                                // * DATATABLE CONFIGURATION
                                            }
                                            <Col sm="12" className={setsearchView1 ? "d-none" : 'pl-0 pr-0 mt-5'} >
                                                <h6 className="mb-3">CUENTAS POR COBRAR Y GESTION</h6>
                                                <CardBody className="pb-5 pl-0 pr-0" style={{ padding: "16px" }}>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "end",
                                                            gap: "12px",
                                                            flexWrap: "wrap"
                                                        }}
                                                    >

                                                        <div style={{ minWidth: "185px", flex: "0 0 185px" }}>
                                                            <Label
                                                                className="f-w-600 mb-1"
                                                                style={{ fontSize: "12px", color: "#495057" }}
                                                            >
                                                                Fecha inicio
                                                            </Label>

                                                            <Input
                                                                type="date"
                                                                value={dateStart}
                                                                onChange={(e) => setDateStart(e.target.value)}
                                                                disabled={loadingView1 || loadingDownload}
                                                                style={{
                                                                    borderRadius: "12px",
                                                                    height: "40px",
                                                                    fontSize: "13px",
                                                                    border: "1px solid #1d5b83"
                                                                }}
                                                            />
                                                        </div>

                                                        <div style={{ minWidth: "185px", flex: "0 0 185px" }}>
                                                            <Label
                                                                className="f-w-600 mb-1"
                                                                style={{ fontSize: "12px", color: "#495057" }}
                                                            >
                                                                Fecha fin
                                                            </Label>

                                                            <Input
                                                                type="date"
                                                                value={dateEnd}
                                                                onChange={(e) => setDateEnd(e.target.value)}
                                                                disabled={loadingView1 || loadingDownload}
                                                                style={{
                                                                    borderRadius: "12px",
                                                                    height: "40px",
                                                                    fontSize: "13px",
                                                                    border: "1px solid #28a745"
                                                                }}
                                                            />
                                                        </div>

                                                        <div style={{ minWidth: "170px", flex: "0 0 170px" }}>
                                                            <Label
                                                                className="f-w-600 mb-1"
                                                                style={{ fontSize: "12px", color: "#495057" }}
                                                            >
                                                                Tipo pago
                                                            </Label>

                                                            <Input
                                                                disabled={loadingView1 || loadingDownload}
                                                                type="select"
                                                                value={paymentType ?? ""}
                                                                onChange={(e) =>
                                                                    setPaymentType(
                                                                        e.target.value === ""
                                                                            ? null
                                                                            : Number(e.target.value)
                                                                    )
                                                                }
                                                                style={{
                                                                    borderRadius: "12px",
                                                                    height: "40px",
                                                                    fontSize: "13px"
                                                                }}
                                                            >
                                                                <option value="">Todos</option>
                                                                <option value="1">Contado</option>
                                                                <option value="2">Crédito</option>
                                                            </Input>
                                                        </div>

                                                        <div
                                                            style={{
                                                                width: "200px",
                                                                minWidth: "200px",
                                                                maxWidth: "200px",
                                                                flex: "0 0 200px",
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            <Label
                                                                className="f-w-600 mb-1"
                                                                style={{
                                                                    fontSize: "12px",
                                                                    color: "#495057"
                                                                }}
                                                            >
                                                                Buscar
                                                            </Label>

                                                            <InputText
                                                                value={searchQuery}
                                                                onChange={handleSearchChange}
                                                                placeholder="Buscar cliente..."
                                                                disabled={loadingView1 || loadingDownload}
                                                                className="w-100"
                                                                style={{
                                                                    width: "100%",
                                                                    boxSizing: "border-box",
                                                                    borderRadius: "12px",
                                                                    height: "40px",
                                                                    fontSize: "13px",
                                                                    border: "1px solid #dee2e6",
                                                                    paddingLeft: "12px"
                                                                }}
                                                            />
                                                        </div>

                                                        <div>
                                                            <Button
                                                                onClick={handleFilterDate}
                                                                color="primary"
                                                                disabled={loadingView1 || loadingDownload}
                                                                style={{
                                                                    borderRadius: "12px",
                                                                    height: "40px",
                                                                    padding: "0 18px",
                                                                    fontWeight: 600,
                                                                    background:
                                                                        "linear-gradient(135deg,#1d5b83,#0d3b59)",
                                                                    border: "none"
                                                                }}
                                                            >
                                                                {loadingView1 ? "Buscando..." : "Buscar"}
                                                            </Button>
                                                        </div>

                                                        <div>
                                                            <Button
                                                                color="success"
                                                                className="btn-download-cxc"
                                                                disabled={loadingView1 || loadingDownload}
                                                                onClick={() => DownloadReportCxc(null, 0, true)}
                                                                style={{
                                                                    borderRadius: "12px",
                                                                    height: "40px",
                                                                    padding: "0 18px",
                                                                    fontWeight: 600,
                                                                    minWidth: "150px",
                                                                    opacity: 1
                                                                }}
                                                            >
                                                                {loadingDownload ? (
                                                                    <div
                                                                        style={{
                                                                            width: "125px",
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            gap: "4px"
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                fontSize: "10px",
                                                                                fontWeight: 700,
                                                                                lineHeight: "12px",
                                                                                color: "#e8f5e9"
                                                                            }}
                                                                        >
                                                                            Descargando {downloadProgress}%
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "6px",
                                                                                background: "rgba(0, 0, 0, 0.18)",
                                                                                borderRadius: "10px",
                                                                                overflow: "hidden"
                                                                            }}
                                                                        >
                                                                            <div
                                                                                style={{
                                                                                    width: `${downloadProgress}%`,
                                                                                    height: "100%",
                                                                                    background: "#b9f6ca",
                                                                                    borderRadius: "10px",
                                                                                    transition: "width 0.4s ease",
                                                                                    boxShadow: "0 0 5px rgba(185, 246, 202, 0.5)"
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    "Descargar"
                                                                )}
                                                            </Button>
                                                        </div>

                                                        {/* <div>
                                                            <Button
                                                                color="success"
                                                                disabled={loadingView1 || loadingDownload}
                                                                onClick={() => DownloadReportCxc(null, 0, true)}
                                                                style={{
                                                                    borderRadius: "12px",
                                                                    height: "40px",
                                                                    padding: "0 18px",
                                                                    fontWeight: 600,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "8px"
                                                                }}
                                                            >
                                                                {loadingDownload ? (
                                                                    <>
                                                                        <i className="pi pi-spin pi-spinner"></i>
                                                                        Descargando...
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <i className="pi pi-download"></i>
                                                                        Descargar
                                                                    </>
                                                                )}
                                                            </Button>
                                                        </div> */}

                                                        <div>
                                                            <Button
                                                                color="danger"
                                                                disabled={loadingView1 ? true : false || loadingDownload}
                                                                onClick={() => handleCleanFilterByClient()}
                                                                style={{
                                                                    borderRadius: "12px",
                                                                    height: "40px",
                                                                    padding: "0 18px",
                                                                    fontWeight: 600
                                                                }}
                                                            >
                                                                Limpiar
                                                            </Button>
                                                        </div>

                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '10px',
                                                                marginLeft: 'auto',
                                                                flexWrap: 'wrap'
                                                            }}
                                                        >

                                                            <div
                                                                className='kpi-card'
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '10px',
                                                                    padding: '6px 12px',
                                                                    borderRadius: '12px',
                                                                    background: 'rgba(34, 197, 94, 0.10)',
                                                                    border: '1px solid rgba(34, 197, 94, 0.25)',
                                                                    height: '40px'
                                                                }}>
                                                                <i className="fa fa-check-circle" style={{ fontSize: '18px', color: '#22c55e' }}></i>

                                                                <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
                                                                    <span style={{ fontSize: '11px', color: '#6c757d' }}>Sin adeudo</span>
                                                                    <span style={{ fontSize: '14px', fontWeight: 700, color: '#22c55e' }}>
                                                                        {filteredClients.filter(row => {
                                                                            const credit = row.totalCredit || 0;
                                                                            const covered = (row.totalPaid || 0) + (row.totalCash || 0);
                                                                            return credit === 0 || covered >= credit;
                                                                        }).length}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div
                                                                className='kpi-card'
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '10px',
                                                                    padding: '6px 12px',
                                                                    borderRadius: '12px',
                                                                    background: 'rgba(239, 68, 68, 0.10)',
                                                                    border: '1px solid rgba(239, 68, 68, 0.25)',
                                                                    height: '40px'
                                                                }}>
                                                                <i className="fa fa-bell" style={{ fontSize: '18px', color: '#ef4444' }}></i>

                                                                <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
                                                                    <span style={{ fontSize: '11px', color: '#6c757d' }}>Con adeudo</span>
                                                                    <span style={{ fontSize: '14px', fontWeight: 700, color: '#ef4444' }}>
                                                                        {filteredClients.filter(row => {
                                                                            const credit = row.totalCredit || 0;
                                                                            const covered = (row.totalPaid || 0) + (row.totalCash || 0);
                                                                            return credit > 0 && covered < credit;
                                                                        }).length}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CardBody>


                                                <Col sm="12">
                                                </Col>

                                                {
                                                    //* DATATABLE CONFIGURATION
                                                }

                                                <DataTable
                                                    value={filteredClients}
                                                    paginator
                                                    rows={10}
                                                    loading={loadingView1}
                                                    responsiveLayout="scroll"
                                                    className="p-datatable-sm"
                                                    dataKey="id_client"
                                                    rowClassName={(rowData) =>
                                                        rowData.active_agreement === false
                                                            ? "row-agreement-deleted"
                                                            : ""
                                                    }

                                                    emptyMessage={
                                                        <div className="text-center py-5">
                                                            <img
                                                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                                style={{ width: "300px", maxWidth: "35%" }}
                                                                alt="Sin resultados"
                                                            />
                                                            <p
                                                                className="mt-3 mb-0"
                                                                style={{
                                                                    fontSize: "15px",
                                                                    color: "#6c757d"
                                                                }}
                                                            >
                                                                No se encontraron resultados.
                                                            </p>
                                                        </div>
                                                    }


                                                >

                                                    <Column
                                                        field="name_client"
                                                        header="Cliente"
                                                        sortable
                                                        headerStyle={headerStyle}
                                                        style={centerStyle}
                                                        body={(row) => (
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "8px"
                                                                }}
                                                            >
                                                                <span>{row.name_client}</span>

                                                                {row.active_agreement === false && (
                                                                    <i
                                                                        className="fa fa-exclamation-triangle"
                                                                        title="Convenio eliminado."
                                                                        style={{
                                                                            color: "#f59e0b",
                                                                            fontSize: "15px",
                                                                            cursor: "pointer",
                                                                            animation: "pulseWarning 1.5s infinite"
                                                                        }}
                                                                    ></i>
                                                                )}
                                                            </div>
                                                        )}
                                                    />

                                                    <Column
                                                        field="rfc_company"
                                                        header="RFC"
                                                        sortable
                                                        headerStyle={headerStyle}
                                                        style={centerStyle}
                                                    />

                                                    <Column
                                                        field="business_name"
                                                        header="Razón social"
                                                        sortable
                                                        headerStyle={headerStyle}
                                                        style={centerStyle}
                                                    />

                                                    <Column
                                                        header="Crédito"
                                                        body={(row) =>
                                                            `$${number_format(row.totalCredit || 0, 2)}`
                                                        }
                                                        headerStyle={headerStyle}
                                                        style={centerStyle}
                                                    />
                                                    <Column
                                                        header="Pagado"
                                                        body={(row) => {
                                                            const totalCredit = Number(row.totalCredit) || 0;
                                                            const totalPaid = Number(row.totalPaid) || 0;
                                                            const totalCash = Number(row.totalCash) || 0;

                                                            const debt = totalCredit - totalPaid;

                                                            const isNoCredit = totalCredit === 0;
                                                            const isPaid = isNoCredit || totalPaid >= totalCredit;
                                                            const hasDebt = totalCredit > 0 && totalPaid < totalCredit;

                                                            return (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        gap: "6px"
                                                                    }}
                                                                >
                                                                    <span style={{ color: hasDebt ? "#ef4444" : "#22c55e" }}>
                                                                        ${number_format(totalPaid, 2)}
                                                                    </span>

                                                                    {hasDebt && (
                                                                        <i
                                                                            className="fa fa-bell debt-alert"
                                                                            title={`Debe $${number_format(debt, 2)}`}
                                                                        ></i>
                                                                    )}

                                                                    {isPaid && (
                                                                        <i
                                                                            className="fa fa-check-circle paid-ok"
                                                                            title={
                                                                                isNoCredit
                                                                                    ? "Sin crédito (pagado al contado)"
                                                                                    : "Cuenta liquidada"
                                                                            }
                                                                        ></i>
                                                                    )}
                                                                </div>
                                                            );
                                                        }}
                                                        headerStyle={headerStyle}
                                                        style={centerStyle}
                                                    />





                                                    <Column
                                                        header="Contado"
                                                        body={(row) =>
                                                            `$${number_format(row.totalCash || 0, 2)}`
                                                        }
                                                        headerStyle={headerStyle}
                                                        style={centerStyle}
                                                    />
                                                    <Column
                                                        header="Acciones"
                                                        headerStyle={headerStyle}
                                                        style={{
                                                            ...centerStyle,
                                                            minWidth: "140px"
                                                        }}
                                                        body={(row) => (
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    gap: "8px"
                                                                }}
                                                            >
                                                                <button
                                                                    onClick={() =>
                                                                        DownloadReportCxc(row?.id_client, 1, false)
                                                                    }
                                                                    title={`Descargar reporte de: ${row?.name_client}`}
                                                                    className="icon-btn"
                                                                    disabled={loadingIdR === row?.id_client}
                                                                    style={{
                                                                        border: "none",
                                                                        background: "#e8f5e9",
                                                                        width: "34px",
                                                                        height: "34px",
                                                                        borderRadius: "10px",
                                                                        cursor: "pointer"
                                                                    }}
                                                                >
                                                                    {loadingIdR === row?.id_client ? (
                                                                        <i className="pi pi-spin pi-spinner text-success"></i>
                                                                    ) : (
                                                                        <i className="pi pi-file-excel text-success"></i>
                                                                    )}
                                                                </button>

                                                                {!dataViewCompany && (
                                                                    <button
                                                                        onClick={() =>
                                                                            handleFilterByClient(
                                                                                row?.id_client,
                                                                                false,
                                                                                false,
                                                                                true
                                                                            )
                                                                        }
                                                                        title={`Detalle de la empresa: ${row?.name_client}`}
                                                                        className="icon-btn"
                                                                        disabled={loadingIdR === row?.id_client}
                                                                        style={{
                                                                            border: "none",
                                                                            background: "#e3f2fd",
                                                                            width: "34px",
                                                                            height: "34px",
                                                                            borderRadius: "10px",
                                                                            cursor: "pointer"
                                                                        }}
                                                                    >
                                                                        {loadingIdR === row?.id_client ? (
                                                                            <i className="pi pi-spin pi-spinner text-primary"></i>
                                                                        ) : (
                                                                            <i className="pi pi-eye text-primary"></i>
                                                                        )}
                                                                    </button>
                                                                )}
                                                            </div>
                                                        )}
                                                    />
                                                </DataTable>





                                            </Col>


                                            {
                                                // * VIEW PATIENTS
                                            }
                                            {
                                                setsearchView1 && <Col sm="12" >

                                                    <CardBody className="pb-5 pl-0 pr-0" style={{ padding: "16px" }}>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "end",
                                                                gap: "12px",
                                                                flexWrap: "wrap"
                                                            }}
                                                        >
                                                            {/* FECHA INICIO */}
                                                            <div style={{ minWidth: "185px", flex: "0 0 185px" }}>
                                                                <Label
                                                                    className="f-w-600 mb-1"
                                                                    style={{ fontSize: "12px", color: "#495057" }}
                                                                >
                                                                    Fecha inicio
                                                                </Label>

                                                                <Input
                                                                    type="date"
                                                                    value={dateStart}
                                                                    onChange={(e) => setDateStart(e.target.value)}
                                                                    disabled={loadingView1}
                                                                    style={{
                                                                        borderRadius: "12px",
                                                                        height: "40px",
                                                                        fontSize: "13px",
                                                                        border: dateStart
                                                                            ? "2px solid #1d5b83"
                                                                            : "1px solid #dee2e6",
                                                                        background: "#fff"
                                                                    }}
                                                                />
                                                            </div>

                                                            {/* FECHA FIN */}
                                                            <div style={{ minWidth: "185px", flex: "0 0 185px" }}>
                                                                <Label
                                                                    className="f-w-600 mb-1"
                                                                    style={{ fontSize: "12px", color: "#495057" }}
                                                                >
                                                                    Fecha fin
                                                                </Label>

                                                                <Input
                                                                    type="date"
                                                                    value={dateEnd}
                                                                    onChange={(e) => setDateEnd(e.target.value)}
                                                                    disabled={loadingView1}
                                                                    style={{
                                                                        borderRadius: "12px",
                                                                        height: "40px",
                                                                        fontSize: "13px",
                                                                        border: dateEnd
                                                                            ? "2px solid #28a745"
                                                                            : "1px solid #dee2e6",
                                                                        background: "#fff"
                                                                    }}
                                                                />
                                                            </div>



                                                            {/* CONVENIO */}
                                                            <div style={{ minWidth: "260px", flex: "0 0 260px" }}>
                                                                <Label
                                                                    className="f-w-600 mb-1"
                                                                    style={{ fontSize: "12px", color: "#495057" }}
                                                                >
                                                                    Convenio
                                                                </Label>

                                                                <Select
                                                                    classNamePrefix="select"
                                                                    name="client_id"
                                                                    value={valuId}
                                                                    options={listAgreement}
                                                                    placeholder="Seleccione convenio"
                                                                    isClearable
                                                                    onChange={(e) => handleChangeAgreement(e)}
                                                                    menuPortalTarget={document.body}
                                                                    isDisabled={loadingView1}
                                                                    styles={{
                                                                        control: (provided) => ({
                                                                            ...provided,
                                                                            minHeight: "40px",
                                                                            borderRadius: "12px",
                                                                            fontSize: "13px"
                                                                        }),
                                                                        valueContainer: (provided) => ({
                                                                            ...provided,
                                                                            height: "40px"
                                                                        }),
                                                                        indicatorsContainer: (provided) => ({
                                                                            ...provided,
                                                                            height: "40px"
                                                                        })
                                                                    }}
                                                                />
                                                            </div>



                                                            {/* BOTÓN BUSCAR */}
                                                            <div>
                                                                <Button
                                                                    onClick={() => handleFilterByClient(filterId, true, true, true)}
                                                                    color="primary"
                                                                    disabled={loadingView1}
                                                                    style={{
                                                                        borderRadius: "12px",
                                                                        height: "40px",
                                                                        padding: "0 18px",
                                                                        fontWeight: 600,
                                                                        background:
                                                                            "linear-gradient(135deg,#1d5b83,#0d3b59)",
                                                                        border: "none"
                                                                    }}
                                                                >
                                                                    {loadingView1 ? "Buscando..." : "Buscar"}
                                                                </Button>
                                                            </div>

                                                            {/* DESCARGAR artmes */}
                                                            <div>
                                                                <Button
                                                                    color="success"
                                                                    disabled={loadingView1}
                                                                    onClick={() => DownloadReportCxc(filterId, 1, false)}
                                                                    style={{
                                                                        borderRadius: "12px",
                                                                        height: "40px",
                                                                        padding: "0 18px",
                                                                        fontWeight: 600
                                                                    }}
                                                                >
                                                                    Descargar
                                                                </Button>
                                                            </div>

                                                            {/* LIMPIAR */}
                                                            <div>
                                                                <Button
                                                                    color="danger"
                                                                    disabled={loadingView1}
                                                                    onClick={handleCleanFilterByClient}
                                                                    style={{
                                                                        borderRadius: "12px",
                                                                        height: "40px",
                                                                        padding: "0 18px",
                                                                        fontWeight: 600
                                                                    }}
                                                                >
                                                                    Limpiar
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </CardBody>




                                                    <div>
                                                        <h4 className='f-w-600' style={{ color: "#0d3b59", fontSize: "18px" }}>Detalles de la Empresa</h4>
                                                        <div className='text-left'>
                                                            <p>Mostrando - {listDetailTransactionsByClients?.length} resultados</p>
                                                        </div>
                                                        <Col sm="12" className='p-l-0 p-r-0 '>
                                                            <Row>
                                                                <Col sm="4" className='p-r-0' >
                                                                    {
                                                                        filterAmount
                                                                            ?
                                                                            <Tag className="mr-2" icon="pi pi-filter" severity="success" value="Efectivo" onClick={() => { setFilterAmount(!filterAmount) }} ></Tag>
                                                                            :
                                                                            <Label type="text" className={`f-w-600 f-12 badge badge${filterAmount ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmount(!filterAmount) }} >Efectivo</Label>
                                                                    }
                                                                    {
                                                                        filterAmountCredit
                                                                            ? <Tag className="mr-2" icon="pi pi-filter" severity="success" value="Crédito" onClick={() => { setFilterAmountCredit(!filterAmountCredit) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAmountCredit ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmountCredit(!filterAmountCredit) }} >Crédito</Label>
                                                                    }
                                                                    {
                                                                        filterAmountDebit
                                                                            ? <Tag className="mr-2" icon="pi pi-filter" severity="success" value="T.D" onClick={() => { setFilterAmountDebit(!filterAmountDebit) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAmountDebit ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmountDebit(!filterAmountDebit) }} >T.D</Label>
                                                                    }
                                                                    {
                                                                        filterAmountTcredit
                                                                            ? <Tag className="mr-2" icon="pi pi-filter" severity="success" value="T.C" onClick={() => { setFilterAmountTcredit(!filterAmountTcredit) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAmountTcredit ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmountTcredit(!filterAmountTcredit) }} >T.C</Label>
                                                                    }
                                                                    {
                                                                        filterAmountTrasferencia
                                                                            ? <Tag className="mr-2" icon="pi pi-filter" severity="success" value="Transferencia" onClick={() => { setFilterAmountTrasferencia(!filterAmountTrasferencia) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAmountTrasferencia ? "" : "-light"}-success`} style={{ cursor: "pointer" }} onClick={() => { setFilterAmountTrasferencia(!filterAmountTrasferencia) }} >Transferencia</Label>
                                                                    }
                                                                </Col>
                                                                <Col sm="8" className='p-l-0' style={{ textAlign: "right" }} >
                                                                    {
                                                                        filterCredit
                                                                            ? <Tag className="mr-2" icon="pi pi-exclamation-triangle" severity="danger" value="Crédito" onClick={() => { setFilterCredit(!filterCredit) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterCredit ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterCredit(!filterCredit) }} >Crédito</Label>
                                                                    }
                                                                    {
                                                                        filterAccount
                                                                            ? <Tag className="mr-2" icon="pi pi-check" severity="warning" value="Contado" onClick={() => { setFilterAccount(!filterAccount) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterAccount ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterAccount(!filterAccount) }} >Contado</Label>
                                                                    }
                                                                    {
                                                                        filterPayment
                                                                            ? <Tag className="mr-2" icon="pi pi-wallet" severity="success" value="Pagado" onClick={() => { setFilterPayment(!filterPayment) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterPayment ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterPayment(!filterPayment) }} >Pagado</Label>
                                                                    }
                                                                    {
                                                                        filterPendingPayment
                                                                            ? <Tag className="mr-2" icon="pi pi-times-circle" severity="danger" value="Pendiente pagado" onClick={() => { setFilterPendingPayment(!filterPendingPayment) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterPendingPayment ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterPendingPayment(!filterPendingPayment) }} >Pendiente pagado</Label>
                                                                    }
                                                                    {
                                                                        filterInvoiced
                                                                            ? <Tag className="mr-2" icon="pi pi-file-pdf" severity="warning" value="Facturado" onClick={() => { setFilterInvoiced(!filterInvoiced) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterInvoiced ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterInvoiced(!filterInvoiced) }} >Facturado</Label>
                                                                    }
                                                                    {
                                                                        filterPendigInvoiced
                                                                            ? <Tag className="mr-2" icon="pi pi-file-pdf" severity="danger" value="Pendiente de facturar" onClick={() => { setFilterPendigInvoiced(!filterPendigInvoiced) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterPendigInvoiced ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterPendigInvoiced(!filterPendigInvoiced) }} >Pendiente de facturar</Label>
                                                                    }
                                                                    {
                                                                        filterPreInvoice
                                                                            ? <Tag className="mr-2" icon="pi pi-file-pdf" severity="warning" value="Prefactura" onClick={() => { setFilterPreInvoice(!filterPreInvoice) }} ></Tag>
                                                                            : <Label type="text" className={`f-w-600 f-12 badge badge${filterPreInvoice ? "" : "-light"}-secondary`} style={{ cursor: "pointer" }} onClick={() => { setFilterPreInvoice(!filterPreInvoice) }} >Prefactura</Label>
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col sm="6" className='pb-2 p-l-0' >
                                                            <InputText
                                                                value={searchQuerys}
                                                                onChange={(e) => setSearchQuerys(e.target.value)}
                                                                placeholder="Buscar..."
                                                                className="p-mb-2"
                                                                style={{ width: '100%' }}
                                                            />
                                                        </Col>




                                                        <DataTable
                                                            value={filteredData}
                                                            dataKey="idWorkOrder"
                                                            paginator
                                                            rows={10}
                                                            rowsPerPageOptions={[10, 50, 100, 200]}
                                                            responsiveLayout="scroll"
                                                            emptyMessage={
                                                                <div className="text-center">
                                                                    <img
                                                                        src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                                        style={{ width: "45%" }}
                                                                        alt="Sin resultados"
                                                                    />
                                                                    <br />
                                                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                                                                        No hay coincidencias con la búsqueda.
                                                                    </p>
                                                                </div>
                                                            }
                                                        >
                                                            <Column header="#" body={(row, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column field="nim" header="NIM" headerStyle={headerStyle} style={centerStyle} />
                                                            <Column field="namePatient" header="Paciente" headerStyle={headerStyle} style={centerStyle} />
                                                            <Column field="nameAgreement" header="Convenio" headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Condición de pago" body={(row) => tagInfo(row.paymentCondition)} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Estado del pago" body={(row) => getTransactionLabel(row.paymentStatus)} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Estatus facturación" body={(row) => getstatusInvoice(row.financialStatus)} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Importe" body={(row) => `$ ${(row?.totalWorkOrder ?? 0).toFixed(2)}`} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Impuesto" body={(row) => `$ ${(row?.totalTax ?? 0).toFixed(2)}`} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Total" body={(row) => `$ ${((row?.totalWorkOrder ?? 0) + (row?.totalTax ?? 0)).toFixed(2)}`} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Iva" body={(row) => getValueTax(row.value_tax)} headerStyle={headerStyle} style={centerStyle} />
                                                            <Column field="serie" header="Serie" headerStyle={headerStyle} style={centerStyle} />
                                                            <Column field="folio" header="Folio" headerStyle={headerStyle} style={centerStyle} />
                                                            <Column field="payMethod" header="Método" headerStyle={headerStyle} style={centerStyle} />
                                                            <Column header="Método de Pago" body={(row) => calculatePaymentMethod(row.id_Pay_method)} headerStyle={headerStyle} style={centerStyle} />
                                                        </DataTable>
                                                    </div>

                                                </Col>
                                            }









                                        </Col>

                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Card>
                </div>

            </div >
















        </Fragment >

    )
}

